import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import PlayerSelector from './PlayerSelector';

const SwapPlayersDialog = ({ isOpen, onClose, onConfirm, availablePlayers }) => {
  const [playerOut, setPlayerOut] = useState('');
  const [playerIn, setPlayerIn] = useState('');

  const handleConfirm = () => {
    if (playerOut && playerIn) {
      onConfirm(playerOut, playerIn);
    }
  };

  return (
    <Dialog open={Boolean(isOpen)} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Trocar jogadores</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <PlayerSelector players={availablePlayers} selectedPlayer={playerOut} onSelect={setPlayerOut} type="Sai (em jogo)" />
          <PlayerSelector players={availablePlayers} selectedPlayer={playerIn} onSelect={setPlayerIn} type="Entra (fila de espera)" />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">Cancelar</Button>
        <Button onClick={handleConfirm} variant="contained" disabled={!playerOut || !playerIn}>Confirmar troca</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SwapPlayersDialog;
